module.exports = __webpack_public_path__ + "static/media/p_14_4.97816af5.png";